import {createSlice} from "@reduxjs/toolkit";
import {aplicarMascaraCEP} from "../../../../lib/formatarCampos";
const initialAtividadesState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  entities: null,
  atividadeForEdit: undefined,
  lastError: null
};
export const callTypes = {
  list: "list",
  action: "action"
};

export const atividadesSlice = createSlice({
  name: "atividades",
  initialState: initialAtividadesState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.listLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.listLoading = true;
      }
    },
    // getAtividadeById
    atividadeFetched: (state, action) => {
      state.listLoading = false;
      // APLICAR A MASCARA
      if (action.payload.atividadeForEdit && action.payload.atividadeForEdit.idAtividade) {
        action.payload.atividadeForEdit.endCEPAtividade = aplicarMascaraCEP(action.payload.atividadeForEdit.endCEPAtividade);
      }
      state.atividadeForEdit = action.payload.atividadeForEdit;
      state.error = null;
    },
    // findAtividades
    atividadesFetched: (state, action) => {
      const { totalCount, entities } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = entities;
      state.totalCount = totalCount;
    },
    // createAtividade
    atividadeCreated: (state, action) => {
      state.listLoading = false;
      state.error = null;
      // state.entities.push(action.payload.atividade);
    },
    // updateAtividade
    atividadeUpdated: (state, action) => {
      state.error = null;
      state.listLoading = false;
      state.entities = state.entities.map(entity => {
        if (entity.id === action.payload.atividade.idAtividade) {
          return action.payload.atividade;
        }
        return entity;
      });
    },
    // deleteAtividade
    atividadeDeleted: (state, action) => {
      state.error = null;
      state.listLoading = false;
      state.entities = state.entities.filter(el => el.id !== action.payload.id);
    },
    // deleteAtividades
    atividadesDeleted: (state, action) => {
      state.error = null;
      state.listLoading = false;
      // state.entities = state.entities.filter(
      //   el => !action.payload.ids.includes(el.id)
      // );
    },
    // atividadesUpdateState
    atividadesAtividadeUpdated: (state, action) => {
      state.listLoading = false;
      state.error = null;
      const { ids, atividade } = action.payload;
      state.entities = state.entities.map(entity => {
        if (ids.findIndex(id => id === entity.id) > -1) {
          entity.atividade = atividade;
        }
        return entity;
      });
    }
  }
});
